module.exports = __webpack_public_path__ + "img/cycle_off.188d4207.svg";